// extracted by mini-css-extract-plugin
export default {"container":"NewChatWidget_container__qT8lH","fullWidthButton":"NewChatWidget_fullWidthButton__kApew","collapsedButton":"NewChatWidget_collapsedButton__VyrAH"};